import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'channelsSiteIdToUrl',
})
export class ChannelsSiteIdToUrlPipe implements PipeTransform {
  transform(site_id: string, eligible_sites: { site_id: string; url: string }[]): string {
    const site = eligible_sites.find((site) => site.site_id === site_id);
    return site ? site.url : 'Site not found';
  }
}
